<template>
  <div id="app">
    <div id="wb">
      <div id="wbbuttons">
        <wb:follow-button class="follow" uid="6751588478" type="red_1" width="67" height="24" ></wb:follow-button>
        <!-- <wb:share-button class="share" appkey="4028851512" addition="simple" type="button" default_text="%E8%B6%85%E5%AE%9E%E7%94%A8%E7%9A%84%E5%B8%81%E7%A7%8D%E8%BD%AC%E6%8D%A2%E5%B7%A5%E5%85%B7%EF%BC%8C%E5%8F%AF%E8%BD%AC%E6%8D%A2%E4%BA%BA%E6%B0%91%E5%B8%81(RMB)%E3%80%81%E7%BE%8E%E5%85%83(USD)%E3%80%81%E6%AC%A7%E5%85%83(EUR)%E3%80%81%E8%8B%B1%E9%95%91(GBP)%E3%80%81%E6%B8%AF%E5%B8%81(HKD)%E3%80%81%E6%BE%B3%E5%85%83(AUD)%E3%80%81%E6%97%A5%E5%85%83(JPY)%E3%80%81%E5%8A%A0%E5%85%83(CAD)%E3%80%81%E6%96%B0%E8%A5%BF%E5%85%B0%E5%85%83(NZD)%E3%80%81%E6%BE%B3%E9%97%A8%E5%B8%81(MOP)%E3%80%81%E6%96%B0%E5%8F%B0%E5%B8%81(TWD)%E3%80%81%E6%B3%B0%E9%93%A2(THB)%E3%80%81%E8%B6%8A%E5%8D%97%E7%9B%BE(VND)%E7%AD%89%E5%A4%9A%E8%BE%BE19%E7%A7%8D%E5%B8%81%E7%A7%8D%EF%BC%8C%E6%B1%87%E7%8E%87%E6%AF%8F%E5%B0%8F%E6%97%B6%E6%9B%B4%E6%96%B0%E4%B8%80%E6%AC%A1~" ralateUid="6751588478" pic="https%3A%2F%2Fwx1.sinaimg.cn%2Fsquare%2F007mUYAmgy1fw5r7ppql5j30280280ne.jpg"></wb:share-button> -->
        <wb:like class="like" appkey="6uB8Gk" type="simple"></wb:like>
      </div>
    </div> 
    <Conversion id="conversion"/>
    <div id="miniprogram">
      <img src="./assets/miniprogram.jpg">
      <div style="font-size:12px;font-weight:bold;">小程序版，了解一下</div>
    </div>
    <div id="bottom">
      <a href="https://beian.miit.gov.cn">粤ICP备18099334号</a>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Conversion from './components/Conversion.vue'

export default {
  name: 'app',
  components: {
    Conversion
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#conversion{
  width:60%;
  margin-left: auto;
  margin-right: auto;
  min-width: 800px;
}
#miniprogram{
  width:12%;
  position: fixed;
  bottom: 5%;
  right: 20px;
}
#miniprogram img{
  width:100%;
  height: 100%;;
}
#wb{
  width:60%;
  margin-left: auto;
  margin-right: auto;
  min-width: 800px;
  height: 30px;
}
#wbbuttons{
  width:190px;
  height: 30px;
  float: right;
}
.follow{
  float: left;
}
.like{
  float: left;
}
.share{
  float: left;
}
#bottom{
  text-align:center;
  height:40px;
  line-height:40px;
}
</style>
